<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">
        <van-cell-group>
            <van-cell  v-for="(subject,index) in row.subject_list" @click="downloadCert(subject)" :key="index" :title="'项目'+(index+1)"   >
                <template #right-icon>
                    <div class="tiny-btn-1" v-if="subject.have_cert">下载证书</div>
                    <!--<div class="tiny-btn-0" v-else>视频已上传</div>-->
                </template>
                <template #label>
                    <div>{{subject.subject_name}}</div>
                    <div>
                        运动员:
                        <span  style="color: #111" v-for="(member,index) in subject.yundongyuan" :key="index">{{member.name}} </span>
                    </div>
                </template>
            </van-cell>

        </van-cell-group>

        <van-popup v-model="showCert" style="width: 80%; height: auto ; text-align: center">
            <img :src="certUrl"  style="width: 100%; text-align: center; height: auto"  />
            <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存</van-button>
            <van-button v-else @click="appDownload" style="margin: 10px auto; text-align: center " type="default" round>点击下载证书</van-button>
        </van-popup>
        <van-overlay :show="loading"    >
        <van-loading type="spinner" v-model="loading" style="text-align: center ; margin-top: 200px;" />
        </van-overlay>

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }


    .bottom-button{
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;
        width: 100%;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        margin-right: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup,Overlay, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Overlay).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiCertList',
        components: {
            PicUploader,
        },
        data: function () {
            return {
                validator,
                loading:false,
                showCert:false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                certUrl:'',
                filename:'',
                areaValue:'',
                submitType:'',
                row:{
                    danwei:{

                    },
                    subject_list:[

                    ]
                },
                formData: {

                },
                isApp:window.isApp()
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.row.id = this.$route.query.id;
            this.fetch();
        },
        watch: {
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            fetch(){
                let that = this;
                that.$api.post('/api/isai/certlist', {
                    id:that.row.id
                }, (res) => {
                    that.row = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },
            downloadCert(subject){
                let that = this;
                that.loading = true;
                that.$api.post('/api/sai/getcert', {
                    subject_id:subject.id
                }, (res) => {
                    console.log(res);
                    that.loading = false;
                    that.showCert = true;
                    that.certUrl = res.data.url;
                    that.filename = res.data.filename;
                }, (res) => {
                    that.loading = true;
                    Toast.fail(res.msg);
                })
            },
            appDownload(){
                let that = this;
                console.log('downloadPic');
                appEvent({
                    name: 'downloadPic',
                    query: {
                        filename: that.filename,
                        url:that.certUrl,
                    }
                });
            }

        }
    }
</script>



// WEBPACK FOOTER //
// SaiCertList.vue?7b6f46f4